import axios from 'axios';
import { getBaseUrl } from '../constants';
import { networkTimeoutThreshold } from './config';
import { logException } from './error-reporting';
import DataLakeTracker from '../tracking/data-lake-tracker';
import { decrypt } from '../secure';

const client = axios.create({});
let Authorization = null;
let customerRefNum = null;
let customerId = null;

// Request interceptor - Log request to datalake
client.interceptors.request.use(
  (config) => {
    let payload;
    const { headers } = config;

    // Envelope-encrypted requests carry the session key in the `Uuid_wp` header
    // and cannot be decrypted with the legacy customerId-derived key. Header
    // names are case-insensitive on the wire, so accept either spelling here.
    if (headers && headers.uuid_wp) {
      Authorization = headers.Authorization || headers.authorization;
      DataLakeTracker({
        logEventType: 'event',
        eventName: config.url,
        eventValue: 'API_CALL_START',
        Authorization: Authorization,
        customerId: customerId === 'null' ? null : customerId,
        customerRefNum: customerRefNum,
      });
      return config;
    }

    customerId = localStorage.getItem(`custId_${config.url.split('/').pop()}`);
    const { data } = config.data;
    if (customerId !== 'null') {
      if (data) {
        payload = decrypt(customerId, data);
        customerRefNum = payload.customerRefNum ? payload.customerRefNum : null;
      } else {
        customerRefNum = null;
      }
    }
    Authorization = headers.Authorization || headers.authorization;
    DataLakeTracker({
      logEventType: 'event',
      eventName: config.url,
      eventValue: 'API_CALL_START',
      Authorization: Authorization,
      customerId: customerId === 'null' ? null : customerId,
      customerRefNum: customerRefNum,
    });
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - Log every response to datalake
client.interceptors.response.use(
  (response) => {
    if (response.status && response.status !== 200) {
      DataLakeTracker({
        logEventType: 'error',
        eventName: response.config.url,
        eventValue: JSON.stringify(response),
        Authorization: Authorization,
        customerId: customerId === 'null' ? null : customerId,
        customerRefNum: customerRefNum,
      });
    } else {
      DataLakeTracker({
        logEventType: 'event',
        eventName: response.config.url,
        eventValue: 'API_CALL_SUCCESS',
        Authorization: Authorization,
        customerId: customerId === 'null' ? null : customerId,
        customerRefNum: customerRefNum,
      });
    }
    return response;
  },
  (error) => {
    const errorResponse = JSON.parse(JSON.stringify(error));
    console.log('Error in API: ', errorResponse);
    customerId = localStorage.getItem(
      `custId_${errorResponse.config.url.split('/').pop()}`
    );
    if (errorResponse.status && errorResponse.status === 403) {
      localStorage.setItem('showSessionExpiredModal', true);
      DataLakeTracker({
        logEventType: 'error',
        eventName: errorResponse.config.url,
        eventValue: JSON.stringify(error),
        Authorization: null,
        customerId: customerId === 'null' ? null : customerId,
        customerRefNum: customerRefNum,
      });
    } else {
      DataLakeTracker({
        logEventType: 'error',
        eventName: errorResponse.config.url,
        eventValue: JSON.stringify(error),
        Authorization: Authorization,
        customerId: customerId === 'null' ? null : customerId,
        customerRefNum: customerRefNum,
      });
    }
    return Promise.reject(error);
  }
);

const url = getBaseUrl();
localStorage.setItem('BASEURL', getBaseUrl());
export default (endpoint, payload = {}, method = 'get', headers = {}) => {
  const axiosConfig = {
    headers,
    method: method.toLowerCase(),
    timeout: networkTimeoutThreshold,
  };
  if (method === 'get') {
    axiosConfig.params = payload;
  } else {
    axiosConfig.data = payload;
  }
  if (endpoint.includes('https://')) {
    return client(endpoint, axiosConfig);
  }
  return client(`${url}${endpoint}`, axiosConfig);
};
